import { useEffect, useState } from "react";
import { Avatar } from "@chakra-ui/react";
import { Tooltip } from "@chakra-ui/react";
import ScrollableFeed from "react-scrollable-feed";
import axios from "../../AxiosInstance";
import { useNavigate } from "react-router-dom";
import "./chat.css";
import {
  getSenderFull,
  isLastMessage,
  isSameSender,
  isSameSenderMargin,
  isSameUser,
} from "../../config/ChatLogics";
import { ChatState } from "../../context/ChatProvider";
import { BASE_URL } from "../../config/BaseUrls";
import { useAuth } from "../../context/auth";
const PRIMARY = "#34c3c9";

const ScrollableChat = ({ messages,isGroup=false }) => {
  const { user } = ChatState();
console.log(isGroup,"isGroupChat")
  const navigate = useNavigate();
  const [auth, setAuth] = useAuth(); // If using Context API

  const userId = auth?.user?._id;

  const [users, setUsers] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return; // Don't make API call if userId is undefined
      try {
        const res = await axios.get(`/api/v1/auth/user-profile/${userId}`);
        setUsers(res.data.data);
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchUser();
  }, [userId]);

  const getChatPartner = (users) => {
    return users?.find((u) => u._id !== user._id);
  };

  const formatDateHeader = (date) => {
    const msgDate = new Date(date);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isToday = msgDate.toDateString() === today.toDateString();
    const isYesterday = msgDate.toDateString() === yesterday.toDateString();

    if (isToday) return "Today";
    if (isYesterday) return "Yesterday";

    // Difference in days
    const diffTime = Math.abs(today - msgDate);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    // Within the last 7 days
    if (diffDays < 7) {
      return msgDate.toLocaleDateString("en-GB", {
        weekday: "long", // e.g., Monday, Tuesday
      });
    }

    // Older than 7 days — show full date
    return msgDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }); // e.g., 04-May-2025
  };

  return (
    <ScrollableFeed>
      {Array.isArray(messages) && messages.length > 0 &&
        messages?.map((m, i) => {
          const partner = getChatPartner(m?.users); // This gets the other user in chat
          console.log("Profile image path:", partner?.profileImage); // <--- Add this line
          console.log("Partner:", partner);
          console.log(
            "Image path:",
            `${BASE_URL}/uploads/${partner?.profileImage}`
          );

          // console.log(
          //   messages[i - 1]?.sender._id === user?._id,
          //   "messages, m, i, user._id"
          // );
          const showDateHeader =
            i === 0 ||
            new Date(m.createdAt).toDateString() !==
            new Date(messages[i - 1].createdAt).toDateString();
          return (
            <div key={m._id}>
              {showDateHeader && (
                <div className="z-10 mx-auto w-fit rounded-full bg-white/90 px-3 py-1 text-xs text-slate-500 ring-1 ring-[#eee]">
                  {formatDateHeader(m.createdAt)}
                </div>
              )}

              <div
                style={
                  m?.sender._id === user?._id
                    ? { display: "flex", flexDirection: "row-reverse" }
                    : { display: "flex" }
                }
                key={m._id}
              >
                {/* {
                  <Tooltip
                    label={m.sender.userName}
                    placement="bottom-start"
                    hasArrow
                  >
                    <img
                      src={
                        m.sender?.profileImage
                          ? `${BASE_URL}/uploads/${m.sender.profileImage}`
                          : require("../../pages/image/addphotoicon.png")
                      }
                      alt={`${partner?.userName || "User"} photo`}
                      onClick={(e) => {
                        e.stopPropagation();

                        navigate(`/ambassadoruserprofile?id=${m.sender?._id}`);
                      }}
                      style={{
                        cursor: "pointer",
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        margin: "10px",
                      }}
                    />
                  </Tooltip>
                } */}
                <span
                  style={{
                    marginLeft: isSameSenderMargin(messages, m, i, user._id),
                    marginTop: isSameUser(messages, m, i, user._id) ? 3 : 10,

                    ["--primary"]: PRIMARY,
                  }}
                  className={`max-w-[78%] rounded-2xl px-3 py-2 text-[13px] shadow-sm ${m?.sender?._id === user?._id
                      ? "bg-[var(--primary)] text-white"
                      : "bg-white text-slate-800 ring-1 ring-[#eee]"
                    }`}
                >
                  {m.content}
                  {m?.image && (
                    <div className="tooltip-container">
                      <img
                        src={m?.image?.startsWith("http")?m?.image:`${BASE_URL}/${m.image}`}
                        alt="Downloadable"
                        className="imageChat"
                        style={{ cursor: "pointer" }}
                        onClick={async () => {
                          try {
                            const response = await fetch(
                             m?.image?.startsWith("http")?m?.image:`${BASE_URL}/${m.image}`,
                              { mode: "cors" }
                            );
                            const blob = await response.blob();
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement("a");
                            link.href = url;
                            link.download = m.image;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(url);
                          } catch (error) {
                            console.error("Download failed:", error);
                          }
                        }}
                      />
                      <span className="tooltip-text">
                        Click here to download
                      </span>
                    </div>
                  )}
                  <div
                    className={`mt-1 flex items-center gap-1 ${m?.sender?._id === user?._id
                        ? "text-white/80"
                        : "text-slate-500"
                      } text-[11px]`}
                  >
                    {new Date(m.createdAt).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </div>{
                    isGroup?.isGroupChat&&
                  <span className="text-[11px] italic text-end inline-block w-100">
                    {m?.sender?.name}
                  </span>
                }
                </span>
                
              </div>
            </div>
          );
        })}
    </ScrollableFeed>
  );
};

export default ScrollableChat;
